"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureLocationEnumToJSON = exports.SignatureLocationEnumFromJSONTyped = exports.SignatureLocationEnumFromJSON = exports.SignatureLocationEnum = void 0;
/**
 * The location of authenticity items such as a seal or signature. This is required for Birth Certificates.
 * @export
 * @enum {string}
 */
var SignatureLocationEnum;
(function (SignatureLocationEnum) {
    SignatureLocationEnum["FRONT"] = "FRONT";
    SignatureLocationEnum["BACK"] = "BACK";
    SignatureLocationEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(SignatureLocationEnum = exports.SignatureLocationEnum || (exports.SignatureLocationEnum = {}));
function SignatureLocationEnumFromJSON(json) {
    return SignatureLocationEnumFromJSONTyped(json, false);
}
exports.SignatureLocationEnumFromJSON = SignatureLocationEnumFromJSON;
function SignatureLocationEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SignatureLocationEnumFromJSONTyped = SignatureLocationEnumFromJSONTyped;
function SignatureLocationEnumToJSON(value) {
    return value;
}
exports.SignatureLocationEnumToJSON = SignatureLocationEnumToJSON;
//# sourceMappingURL=SignatureLocationEnum.js.map